import ReactDOM from 'react-dom/client';
import './index.css';
import { AltosDeAzpitiaApp } from './AltosDeAzpitiaApp';
import { BrowserRouter } from 'react-router-dom';

import './i18n' //Gestor de Idiomas

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <BrowserRouter>
        <AltosDeAzpitiaApp />
    </BrowserRouter>
  
);

